import { cookieGet } from '@Infra/Cookie';

const JWT_HP_COOKIE_NAME = 'jwt_hp';

/**
 * `jwt_hp` (header + payload) is deliberately readable by the front, unlike the httpOnly signature
 * cookie: its mere presence answers "was a session opened on this browser", without decoding it.
 */
export const hasOpenedSession = (): boolean => {
	return cookieGet(JWT_HP_COOKIE_NAME) !== null;
};
